<template>
  <div class="coupon-module">
    <div class="section-title">选择领券模块样式</div>
    <div class="coupon-style-grid">
      <div
        v-for="style in couponStyles"
        :key="style.value"
        class="coupon-style-item"
        :class="{ active: value.switchStyleType === style.value }"
        @click="value.switchStyleType = style.value"
      >
        <img class="style-preview-img" :src="style.image" :alt="style.label">
      </div>
    </div>

    <div class="coupon-bind-header">
      <div class="section-title">关联优惠券</div>
      <a-button type="primary" icon="plus" @click="onAddCoupon">新建</a-button>
    </div>
    <a-table
      row-key="couponCode"
      size="middle"
      :columns="couponColumns"
      :data-source="value.coupons"
      :pagination="couponPagination"
      :row-selection="{ selectedRowKeys: selectedCouponRowKeys, onChange: onCouponSelectChange }"
      @change="onCouponTableChange"
    >
      <template slot="action" slot-scope="text, record">
        <a @click="onRemoveCoupon(record)">移除</a>
      </template>
    </a-table>

    <selected-product-dialog
      :show="showCouponDialog"
      title="优惠券列表"
      :width="1100"
      :col="3"
      :item-names="['search_couponCode', 'search_distributeWay', 'search_status']"
      :query-params="couponQueryParams"
      :request-promise="loadCouponPage"
      :columns="couponDialogColumns"
      row-key="couponCode"
      :custom-pagination="true"
      :row-selection="couponDialogRowSelection"
      @close="showCouponDialog = false"
    >
      <a-form-item
        slot="search_couponCode"
        label="优惠券ID"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-input
          v-model="couponQueryParams.couponCode"
          placeholder="请输入"
          allow-clear
        />
      </a-form-item>
      <a-form-item
        slot="search_distributeWay"
        label="派券方式"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-select
          v-model="couponQueryParams.distributeWay"
          placeholder="请选择"
          allow-clear
          style="width: 100%"
          :options="distributeWayOptions"
        />
      </a-form-item>
      <a-form-item
        slot="search_status"
        label="状态"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-select
          v-model="couponQueryParams.status"
          placeholder="请选择"
          allow-clear
          style="width: 100%"
          :options="statusOptions"
        />
      </a-form-item>
      <template slot="faceAmount" slot-scope="rowItem">
        <span v-if="rowItem.record.couponType === 2">{{ rowItem.record.discountRate }} 折</span>
        <span v-else>¥ {{ rowItem.record.couponAmt }}</span>
      </template>
      <div slot="footer" class="coupon-select-footer">
        <a-button @click="showCouponDialog = false">取消</a-button>
        <a-button type="primary" @click="onConfirmSelectCoupons">确定</a-button>
      </div>
    </selected-product-dialog>
  </div>
</template>

<script>
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog.vue'
import {
  COUPON_STATUS,
  DISTRIBUTE_WAY,
  toSelectOptions
} from '@/views/service_new/coupon/constants/couponConstants'

const COUPON_COLUMNS = [
  { title: '优惠券ID', dataIndex: 'couponCode', width: 180 },
  { title: '优惠券标题', dataIndex: 'couponName', ellipsis: true },
  { title: '状态', dataIndex: 'statusName', width: 100 },
  {
    title: '操作',
    dataIndex: 'action',
    width: 100,
    scopedSlots: { customRender: 'action' }
  }
]

const COUPON_DIALOG_COLUMNS = [
  { title: 'ID', dataIndex: 'couponCode', width: 180 },
  { title: '优惠券标题', dataIndex: 'couponName', width: 160, ellipsis: true },
  { title: '券类型', dataIndex: 'couponTypeStr', width: 100 },
  {
    title: '面额',
    dataIndex: 'couponAmt',
    width: 100,
    scopedSlots: { customRender: 'faceAmount' }
  },
  { title: '派券方式', dataIndex: 'distributeWayStr', width: 120 },
  { title: '开始时间', dataIndex: 'receiveStartTimeStr', width: 170 },
  { title: '状态', dataIndex: 'statusStr', width: 90 }
]

export default {
  name: 'ActivityCouponModule',
  components: {
    SelectedProductDialog
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      couponStyles: [
        {
          value: 1,
          label: '领券模块样式1',
          image: 'https://imgbtest.woyoubooking.com/test/base/42dcffaf8a784a759d7fb315a23621a2.png'
        },
        {
          value: 2,
          label: '领券模块样式2',
          image: 'https://imgbtest.woyoubooking.com/test/base/1ed0c7c0b44c4c2e8788df185eb18d3e.png'
        },
        {
          value: 3,
          label: '领券模块样式3',
          image: 'https://imgbtest.woyoubooking.com/test/base/19db7520f4a64354b105874172cfc544.png'
        },
        {
          value: 4,
          label: '领券模块样式4',
          image: 'https://imgbtest.woyoubooking.com/test/base/42dcffaf8a784a759d7fb315a23621a2.png'
        }
      ],
      couponColumns: COUPON_COLUMNS,
      couponDialogColumns: COUPON_DIALOG_COLUMNS,
      distributeWayOptions: toSelectOptions(DISTRIBUTE_WAY),
      statusOptions: toSelectOptions(COUPON_STATUS),
      selectedCouponRowKeys: [],
      couponPage: {
        current: 1,
        pageSize: 5
      },
      showCouponDialog: false,
      couponQueryParams: {
        couponCode: '',
        distributeWay: undefined,
        status: undefined
      },
      dialogSelectedKeys: [],
      dialogSelectedRows: []
    }
  },
  computed: {
    couponDialogRowSelection () {
      return {
        selectedRowKeys: this.dialogSelectedKeys,
        onChange: this.onDialogSelectChange
      }
    },
    couponPagination () {
      const total = (this.value.coupons || []).length
      return {
        current: this.couponPage.current,
        pageSize: this.couponPage.pageSize,
        total,
        showTotal: t => `共 ${t} 条记录`
      }
    }
  },
  created () {
    if (!Array.isArray(this.value.coupons)) {
      this.$set(this.value, 'coupons', [])
    }
    if (this.value.switchStyleType == null) {
      this.$set(this.value, 'switchStyleType', 1)
    }
  },
  methods: {
    onAddCoupon () {
      this.dialogSelectedKeys = []
      this.dialogSelectedRows = []
      this.couponQueryParams = {
        couponCode: '',
        distributeWay: undefined,
        status: undefined
      }
      this.showCouponDialog = true
    },
    loadCouponPage (params) {
      const { limitDto, couponCode, distributeWay, status } = params || {}
      return this.getHttpServices()
        .getNewServeService()
        .post('/coupon/page', {
          couponCode: couponCode || '',
          distributeWay: distributeWay == null || distributeWay === '' ? null : Number(distributeWay),
          status: status == null || status === '' ? null : Number(status),
          limitDto
        })
    },
    onDialogSelectChange (selectedRowKeys, selectedRows) {
      this.dialogSelectedKeys = selectedRowKeys
      this.dialogSelectedRows = selectedRows
    },
    onConfirmSelectCoupons () {
      if (!this.dialogSelectedRows.length) {
        this.$message.warning('请先选择优惠券')
        return
      }
      // 追加到已有关联列表，按 couponCode 去重，避免新建时覆盖旧券
      const existing = Array.isArray(this.value.coupons) ? this.value.coupons : []
      const existingCodes = new Set(existing.map(item => item.couponCode))
      const toAdd = this.dialogSelectedRows
        .filter(item => item.couponCode && !existingCodes.has(item.couponCode))
        .map(item => ({
          couponCode: item.couponCode,
          couponName: item.couponName,
          statusName: item.statusStr || ''
        }))
      this.value.coupons = [...existing, ...toAdd]
      this.selectedCouponRowKeys = []
      this.couponPage.current = 1
      this.showCouponDialog = false
      this.$message.success(toAdd.length ? '已更新关联优惠券' : '所选优惠券已关联，无需重复添加')
    },
    onRemoveCoupon (record) {
      this.value.coupons = this.value.coupons.filter(item => item.couponCode !== record.couponCode)
      this.selectedCouponRowKeys = this.selectedCouponRowKeys.filter(key => key !== record.couponCode)
      this.$message.success('已移除')
    },
    onCouponSelectChange (selectedRowKeys) {
      this.selectedCouponRowKeys = selectedRowKeys
    },
    onCouponTableChange (pagination) {
      this.couponPage = {
        current: pagination.current,
        pageSize: pagination.pageSize
      }
    }
  }
}
</script>

<style scoped lang="less">
.coupon-module {
  flex: 1;
  min-width: 0;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.section-title {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.coupon-style-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 24px;
}

.coupon-style-item {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  // background: #1a120b;

  &.active {
    border-color: #1890ff;
  }
}

.style-preview-img {
  display: block;
  width: 100%;
  height: auto;
  vertical-align: top;
}

.coupon-bind-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  .section-title {
    margin-bottom: 0;
  }
}

.coupon-select-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}
</style>
